import * as React from "react";
import type { SVGProps } from "react";
const SvgHouseBadgePlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.5 1C20.53 1 23 3.47 23 6.5c0 1.7-.78 3.23-2 4.24V21c0 .55-.45 1-1 1h-6c-.55 0-1-.45-1-1v-5h-2v5c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V9c0-.31.15-.61.4-.8l8-6a.99.99 0 0 1 1.2 0l.83.62C14.43 1.71 15.88 1 17.5 1ZM15 20h4v-8.21c-.48.13-.98.21-1.5.21A5.51 5.51 0 0 1 12 6.5c0-.69.13-1.36.37-1.97L12 4.25 5 9.5V20h4v-5c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v5ZM14 6.5c0 1.93 1.57 3.5 3.5 3.5S21 8.43 21 6.5 19.43 3 17.5 3 14 4.57 14 6.5Zm4.5-1h.5c.55 0 1 .45 1 1s-.45 1-1 1h-.5V8c0 .55-.45 1-1 1s-1-.45-1-1v-.5H16c-.55 0-1-.45-1-1s.45-1 1-1h.5V5c0-.55.45-1 1-1s1 .45 1 1v.5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgHouseBadgePlus;
